const recentlyProducts = {
  FILL_RECENTLY_PRODUCTS: "FILL_RECENTLY_PRODUCTS"
};
export default recentlyProducts;